import React from 'react';
import { Table } from 'react-bootstrap';
import { StyleSetup } from '../../models/style';

type Props = {
    renderTableRows: () => (JSX.Element | null)[] | undefined;
    styleConfig: StyleSetup;
    headers: string[];
    theadStyle?: React.CSSProperties;
    tbodyStyle?: React.CSSProperties;
    theadCentered?: boolean;
    tbodyCentered?: boolean;
};

export const TableCustom = (props: Props) => {
    return (
        <React.Fragment>
            <Table bordered responsive className='table-custom'>
                <thead style={{ ...props.styleConfig.member_detail_box, ...props.theadStyle }} className={`${props.theadCentered ? 'center' : ''}`}>
                    <tr>
                        {props.headers.map((item) => {
                            return <th className='header-field'>{item}</th>
                        })}
                    </tr>
                </thead>
                <tbody style={props.tbodyStyle} className={`${props.tbodyCentered ? 'center' : ''}`}>
                    {props.renderTableRows()}
                </tbody>
            </Table>
        </React.Fragment>
    );
};
